import InitActions from '../pages/InitActions';
import WebsiteEntityPage from '../pages/WebsiteEntityPage';
import HomePage from '../pages/HomePage';
import ServicePage from '../pages/ServicePage';
import CategoryPage from '../pages/CategoryPage';
import ProductPage from '../pages/ProductPage';
import WebsitePage from '../pages/WebsitePage';
import ServiceEntityPage from '../pages/ServiceEntityPage';
import ProductEntityPage from '../pages/ProductEntityPage';
import UserProfilePage from '../pages/UserProfilePage';
import UserfavouritePage from '../pages/UserfavouritePage';
import SearchResultPage from '../pages/SearchResultPage';
import ResultsPage from '../pages/ResultsPage';
import OffersPage from '../pages/OffersPage';
export default {
  home: {
    path: '/',
    method: 'get',
    page: 'home',
    title: 'Home',
    handler: HomePage,
    action: InitActions.Homepage
  },
  category: {
    path: '/category/:id',
    method: 'get',
    page: 'category',
    title: 'Category',
    handler: CategoryPage,
    action: InitActions.Categorypage
  },
  login: {
    path: '/login',
    method: 'get',
    page: 'login',
    title: 'Login',
    handler: require('../components/Login')
  },
  profile: {
    path: '/profile',
    method: 'get',
    page: 'profile',
    handler: UserProfilePage,
    action: InitActions.UserProfilePage
  },
  websiteEntity: {
    path: '/website/:id',
    method: 'get',
    page: 'website',
    title: 'Website',
    handler: WebsiteEntityPage,
    action: InitActions.Websitepage
  },
  userfavourite: {
    path: '/userfavourite/:id',
    method: 'get',
    page: 'userfavourite',
    title: 'userfavourite',
    handler: UserfavouritePage,
    action: InitActions.UserfavouritePage
  },
  services: {
    path: '/services',
    method: 'get',
    page: 'services',
    title: 'Service',
    handler: ServicePage,
    action: InitActions.Servicepage
  },
  products: {
    path: '/products',
    method: 'get',
    page: 'products',
    title: 'Products',
    handler: ProductPage,
    action: InitActions.Productpage
  },
  websites: {
    path: '/websites',
    method: 'get',
    page: 'websites',
    title: 'websites',
    handler: WebsitePage,
    action: InitActions.Websitelandingpage
  },
  ServiceEntity: {
    path: '/Service/:id',
    method: 'get',
    page: 'service',
    title: 'Service',
    handler: ServiceEntityPage,
    action: InitActions.Serviceentitypage
  },
  ProductEntity: {
    path: '/product/:id',
    method: 'get',
    page: 'product',
    title: 'product',
    handler: ProductEntityPage,
    action: InitActions.Productentitypage
  },
  Privacy: {
    path: '/privacy',
    method: 'get',
    page: 'privacy',
    title: 'Privacy',
    handler: require('../components/Privacy')
  },
  signup: {
    path: '/signup',
    method: 'get',
    page: 'signup',
    title: 'Signup',
    handler: require('../components/Signup')
  },
  Terms: {
    path: '/terms',
    method: 'get',
    page: 'terms',
    title: 'Terms',
    handler: require('../components/Terms')
  },
  error: {
    path: '/error',
    method: 'get',
    page: 'error',
    title: '404 Error',
    handler: require('../components/Error')
  },
  entertainer: {
    path: '/entertainer',
    method: 'get',
    page: 'entertainer',
    title: 'Entertainer',
    handler: require('../components/Entertainer')
  },
  entertainerResult: {
    path: '/searchResults',
    method: 'get',
    page: 'EntertainerResult',
    title: 'Entertainer Result',
    handler: SearchResultPage,
    action: InitActions.SearchResults
  },
  results: {
    path: '/results/:id',
    method: 'get',
    page: 'Results',
    title: 'Results',
    handler: ResultsPage,
    action: InitActions.ResultsPage
  },
  entertainerInputPage: {
    path: '/userinput',
    method: 'get',
    page: 'UserInput',
    title: 'User Input',
    handler: require('../components/EntertainerInput')
  },
  offers: {
    path: '/offers/:id',
    method: 'get',
    page: 'Offers',
    title: 'Offers',
    handler: OffersPage,
    action: InitActions.getOffers
  }
};



// WEBPACK FOOTER //
// ./src/configs/routes.js